import type { Category } from "@/constants/categories";

// Keep this file structurally compatible with `Product` from `products.ts`,
// without importing `Product` to avoid circular dependencies.
type BisPcProduct = {
  id: string;
  name: string;
  categorySlug: Category["slug"];
  brand: string;
  price: number;
  unit: string;
  image: string;
};

const IMG = {
  biscuits:
    "https://images.unsplash.com/photo-1558961363-fa8fdf82db35?crop=entropy&cs=srgb&fm=jpg&q=85",
  personal:
    "https://images.unsplash.com/photo-1556228720-195a672e8a03?crop=entropy&cs=srgb&fm=jpg&q=85",
};

const item = (
  id: string,
  name: string,
  brand: string,
  unit: string,
  price: number,
  image: string,
): BisPcProduct => ({
  id,
  name,
  categorySlug: "bispc",
  brand,
  unit,
  price,
  image,
});

export const BISPC_PRODUCTS: BisPcProduct[] = [
  // Biscuits (common + screenshot-inspired)
  item("bpc-britannia-goodday-45g", "Good Day Butter Biscuits", "Britannia", "45g", 2.5, IMG.biscuits),
  item("bpc-britannia-marie-150g", "Marie Gold Biscuits", "Britannia", "150g", 6.5, IMG.biscuits),
  item("bpc-britannia-pure-malt-55g", "Pure Malt Biscuits", "Britannia", "55g", 3.0, IMG.biscuits),
  item("bpc-parle-g-44g", "Parle-G Original Biscuits", "Parle", "44g", 1.25, IMG.biscuits),
  item("bpc-hide-seek-choco-30g", "Hide & Seek Choco", "Hide & Seek", "30g", 10.99, IMG.biscuits),
  item("bpc-hide-seek-strawberry-30g", "Hide & Seek Strawberry", "Hide & Seek", "30g", 10.99, IMG.biscuits),
  item("bpc-hide-seek-corn-30g", "Hide & Seek Cornflakes", "Hide & Seek", "30g", 10.99, IMG.biscuits),
  item("bpc-oreo-classic-154g", "Oreo Cookies", "Oreo", "154g", 6.99, IMG.biscuits),
  item("bpc-oreo-mini-166g", "Oreo Mini Cookies", "Oreo", "166g", 7.49, IMG.biscuits),
  item("bpc-kelloggs-coco-40g", "Kellogg's Coco Cookies", "Kellogg's", "40g", 3.49, IMG.biscuits),
  item("bpc-kelloggs-crunch-45g", "Kellogg's Crunch Cookies", "Kellogg's", "45g", 4.29, IMG.biscuits),

  // Namkeen / snacks (often mixed into biscuits aisles)
  item("bpc-bikaji-bhujia-200g", "Bhujia", "Bikaji", "200g", 6.99, IMG.biscuits),
  item("bpc-bikaji-choom-200g", "Chana Chaat Mix", "Bikaji", "200g", 7.49, IMG.biscuits),
  item("bpc-haldiram-mixture-200g", "Mixture", "Haldiram's", "200g", 8.49, IMG.biscuits),

  // Personal care (screenshot shows mixed shelf)
  item("bpc-dettol-handwash-500ml", "Dettol Handwash", "Dettol", "500ml", 249.0, IMG.personal),
  item("bpc-colgate-toothpaste-100g", "Colgate Toothpaste", "Colgate", "100g", 140.0, IMG.personal),
  item("bpc-clinicplus-shampoo-340ml", "Clinic Plus Shampoo", "Clinic Plus", "340ml", 179.0, IMG.personal),
  item("bpc-dove-soap-100g", "Dove Soap", "Dove", "100g", 79.0, IMG.personal),
  item("bpc-fair-n-lovely-100ml", "Fair & Lovely Cream", "Fair & Lovely", "100ml", 299.0, IMG.personal),
  item("bpc-garnier-facewash-100ml", "Garnier Face Wash", "Garnier", "100ml", 299.0, IMG.personal),

  // More biscuits for density
  item("bpc-parle-hide-55g", "Hide & Seek Cookies", "Hide & Seek", "55g", 14.99, IMG.biscuits),
  item("bpc-parle-marie-250g", "Marie Gold (Family Pack)", "Britannia", "250g", 11.99, IMG.biscuits),
  item("bpc-oreo-family-400g", "Oreo Family Pack", "Oreo", "400g", 24.99, IMG.biscuits),
  item("bpc-britannia-bake-88g", "Britannia Bake Cookies", "Britannia", "88g", 5.49, IMG.biscuits),
];

